var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "p",
        [
          (_vm.orderDetail?.extra_data?.comments ?? []).length
            ? _c(
                "v-popover",
                {
                  staticClass: "d-inline",
                  attrs: { "auto-hide": true, placement: "bottom" },
                },
                [
                  _c("i", {
                    staticClass:
                      "comment_tooltip_fa icon-fa icon-fa-info-circle",
                  }),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "popover" },
                    _vm._l(_vm.orderDetail.extra_data.comments, function (c) {
                      return _c("p", [_vm._v(_vm._s(c.text))])
                    }),
                    0
                  ),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.orderDetail.new_drug.cool
            ? _c("span", [
                _c("i", { staticClass: "cool_mark_list icon icon-snowflake" }, [
                  _vm._v(" "),
                ]),
              ])
            : _vm._e(),
          _vm._v(
            _vm._s(_vm.orderDetail.new_drug.title) +
              "\n    (" +
              _vm._s(_vm.orderDetail.drug_id) +
              ")\n  "
          ),
        ],
        1
      ),
      _vm._v(" "),
      +_vm.orderDetail.new_drug.pack_set !== 1
        ? [
            _c("p", [
              _c("strong", [
                _vm._v(
                  _vm._s(
                    Math.round(
                      (_vm.orderDetail.qty /
                        _vm.orderDetail.new_drug.pack_set) *
                        100
                    ) / 100
                  )
                ),
              ]),
              _vm._v(" (компл) *\n      "),
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm.orderDetail.price * _vm.orderDetail.new_drug.pack_set
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [_vm._v(_vm._s(_vm.orderDetail.qty))]),
              _vm._v(" завод.упак. "),
              _c("strong", [_vm._v("x " + _vm._s(_vm.orderDetail.price))]),
            ]),
          ]
        : [
            _c("p", [
              _c("strong", [
                _vm._v(
                  "x " +
                    _vm._s(_vm.orderDetail.qty) +
                    " x " +
                    _vm._s(_vm.orderDetail.price)
                ),
              ]),
              _vm._v(" "),
              _vm.order.currency_id &&
              _vm.order.currency_id !==
                _vm.$platformConstants.operationCurrency.id
                ? _c("span", [
                    _vm._v(" ("),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.orderDetail.currency_price)),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$AllCurrencies[_vm.order.currency_id]?.currency
                        ) +
                        ")"
                    ),
                  ])
                : _vm._e(),
            ]),
          ],
      _vm._v(" "),
      _c("div", { staticClass: "flex flex_gap_10" }, [
        _vm.showOutsorceOrder
          ? _c(
              "div",
              [
                _c(
                  "v-popover",
                  { attrs: { "auto-hide": true, placement: "left" } },
                  [
                    _c("span", { staticClass: "badge badge-danger pointer" }, [
                      _vm._v("заказ с сайта"),
                    ]),
                    _vm._v(" "),
                    _c("template", { slot: "popover" }, [
                      _c("p", [_vm._v(_vm._s(_vm.request.title))]),
                      _vm._v(" "),
                      _c("p", [
                        _c("strong", [_vm._v(_vm._s(_vm.request.qty))]),
                        _vm._v("уп. по "),
                        _c("strong", [_vm._v(_vm._s(_vm.request.price))]),
                        _vm._v("р\n            ("),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.request.qty * _vm.request.price)),
                        ]),
                        _vm._v("р)"),
                      ]),
                    ]),
                  ],
                  2
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }